import { KyInstance } from 'ky';
import qs from 'qs';

import { SubscriptionDowngradeQuestion } from './subscription-downgrade-questions.model';
import { CommonQueryParams, CommonResponse } from '../common';

export async function getSubscriptionDowngradeQuestions(
  httpClient: KyInstance,
  options: CommonQueryParams,
): Promise<CommonResponse<SubscriptionDowngradeQuestion>> {
  const searchParams = qs.stringify({ populate: '*', ...options });
  const response = await httpClient.get('subscription-downgrade-questions', {
    searchParams,
  });
  return response.json();
}
